module.exports = __webpack_public_path__ + "img/cambodia-bg-mobile.24f7d0ce.webp";